import React from "react";

export function ProviderComposer({ providers = [], children }) {
  return (providers || []).filter(Boolean).reduceRight((acc, P, i) => {
    if (React.isValidElement(P)) {
      return React.cloneElement(P, P.props, acc);
    }

    if (typeof P === "function") {
      const Comp = P;
      return <Comp key={Comp.displayName || Comp.name || i}>{acc}</Comp>;
    }
    console.warn("ProviderComposer: invalid provider at index", i, P);
    return acc;
  }, children);
}
